import { useMutation } from '@tanstack/react-query';

import type { AcceptInvitationBody } from '../../../types/extranet-api.types';
import { getExtranetApi } from '../extranetApi';

/**
 * `POST /v1/auth/invitation/accept` (public) — définit le mot de passe et
 * finalise l'invitation (204). Les rôles sont lus côté serveur depuis
 * l'invitation. Enchaîner ensuite sur `useExtranetLogin`.
 */
export const useAcceptInvitation = () =>
  useMutation({
    mutationFn: (body: AcceptInvitationBody) =>
      getExtranetApi().post<AcceptInvitationBody, void>('/v1/auth/invitation/accept', body, { skipAuth: true }),
  });
